export enum ScheduledJobTypeEnum {
  DOWNGRADED_LIMIT = 'downgraded-limit'
}
